import { defineStore } from 'pinia'
import { useApiRequest } from '@/api'
import { type BrandKit, useBrandColorsResource } from '../resources'
import { useBrandKitStore } from './brand-kit.store'

type ColorsResource = ReturnType<typeof useBrandColorsResource>
type ReplaceColorsBody = Parameters<ColorsResource['setBrandColors']>[2]

export const useBrandColorsStore = defineStore('brand-colors', () => {
  const { setBrandColors, setBrandShade } = useBrandColorsResource()
  const kitStore = useBrandKitStore()
  const { run, loading, failure } = useApiRequest()

  // A colour save rebuilds the shades of every changed colour on the server, so the kit is read again whole.
  const saveColors = async (organizationId: string, brandId: string, body: ReplaceColorsBody) => {
    const colors = await run<BrandKit['colors']>(() => setBrandColors(organizationId, brandId, body))
    if (colors) await kitStore.loadKit(organizationId, brandId)
    return colors
  }

  const saveShade = async (organizationId: string, brandId: string, shadeId: string, hex: string) => {
    const shade = await run<BrandKit['shades'][number]>(() => setBrandShade(organizationId, brandId, shadeId, hex))
    const kit = kitStore.kits[brandId]
    if (shade && kit)
      kitStore.kits = { ...kitStore.kits, [brandId]: { ...kit, shades: kit.shades.map(entry => (entry.id === shade.id ? shade : entry)) } }
    return shade
  }

  return { loading, failure, saveColors, saveShade }
})
